<template>
  <section class="gift-cards-section">
    <div class="gift-cards-section__container">
      <div class="box">
        <div class="content">
          <h3 class="title">
            {{ $t('pages.ssrGiftCards.pricingBlock.title') }}
          </h3>
          <p class="text">
            {{ $t('pages.ssrGiftCards.pricingBlock.text') }}
          </p>
          <RssUiButton
            rainbow
            class="switch-section__link lp-button"
            data-test-id="buttonGiftCardsCTA"
            :to="$locatedLink('/gift-cards/')"
          >
            {{ $t('pages.ssrGiftCards.pricingBlock.buttonLabel') }}
          </RssUiButton>
        </div>
        <Illustration class="illustration" />
      </div>
    </div>
  </section>
</template>

<script>
import Illustration from './Illustration.vue'

export default {
  name: 'PricingGifts',
  components: {
    Illustration
  }
}
</script>

<style lang="scss" scoped>
.gift-cards-section {
  padding-top: $gap * 3.5;
  padding-bottom: 0;

  @include display-less(tablet) {
    padding: 0 $gap;
  }

  &__container {
    width: 1152px;
    margin: 0 auto;
    max-width: 100%;
  }
}

.box {
  overflow: hidden;
  position: relative;
  padding: $gap * 4 18%;
  background-color: #25163A;

  @include display-less(tablet) {
    padding: $gap * 4 $gap * 1.5;
  }
}

.content {
  z-index: 2;
  display: flex;
  position: relative;
  text-align: center;
  align-items: center;
  flex-direction: column;
}

.illustration {
  right: -80px;
  bottom: -30px;
  position: absolute;
  transform: rotate(-23.13deg);

  @include display-less(tablet) {
    right: -170px;
    bottom: 20px;
  }
}

.title {
  color: #fff;
  font-size: 24px;
  line-height: 150%;
  font-weight: bold;
  text-align: center;
  margin-bottom: $gap;
}

.text {
  color: #fff;
  margin-top: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  margin-bottom: $gap;

  ::v-deep strong {
    color: #fff;
  }

  @include display-less(tablet) {
    font-size: 16px;
  }
}
</style>
